import {ChangeDetectionStrategy, Component, inject, input, output} from '@angular/core';
import {CdkDrag, CdkDragDrop, CdkDragHandle, CdkDropList, moveItemInArray} from "@angular/cdk/drag-drop";
import {FileCardComponent} from "../../../../../../../../shared/components/ui/file-card/file-card.component";
import {EntityFileType} from "../../../../../../../../core/types/file.types";
import {BannerSocialFilesStateService} from "../../services/banner-social-files-state.service";
import {BannerSocialFilesService} from "../../services/banner-social-files.service";
import {BannerSocialFilesSyncService} from "../../services/banner-social-files-sync.service";
import {BannerSocialFilePathStateService} from "../../services/banner-social-file-path-state.service";
import {BannerSocialFileData} from "../../types/banners-social-modal.types";
import {DeleteFileParams} from "../../../../../types/product-card-files.types";

@Component({
  selector: 'app-banners-social-file-library',
  imports: [
    CdkDrag,
    CdkDragHandle,
    CdkDropList,
    FileCardComponent
  ],
  templateUrl: './banners-social-file-library.component.html',
  styleUrl: './banners-social-file-library.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BannersSocialFileLibraryComponent {
  isEditModeActive = input<boolean>(false);
  bannerSocialEntityFileType = input<EntityFileType>('BANNERS');
  getFiles = output<void>();

  public bannerSocialFilesStateService: BannerSocialFilesStateService = inject(BannerSocialFilesStateService);
  private bannerSocialFilesService: BannerSocialFilesService = inject(BannerSocialFilesService);
  private bannerSocialFilesSyncService: BannerSocialFilesSyncService = inject(BannerSocialFilesSyncService);
  private bannerSocialFilePathStateService: BannerSocialFilePathStateService = inject(BannerSocialFilePathStateService);

  public handleDelete(isImage: boolean, file: BannerSocialFileData): void {
    const params: DeleteFileParams = {
      path: this.bannerSocialFilePathStateService.pathFileState(),
      id: file.id
    };

    this.bannerSocialFilesService.deleteFile(params)
      .then(() => this.bannerSocialFilesStateService.deleteFileById(file.id));
  }

  public async handleDrop(event: CdkDragDrop<Array<BannerSocialFileData>>): Promise<void> {
    const oldFiles = this.bannerSocialFilesStateService.bannerSocialFilesState();
    const newFiles = [...oldFiles];
    moveItemInArray(newFiles, event.previousIndex, event.currentIndex);

    const updatedFiles = newFiles.map((file, index) => ({
      ...file,
      priority: index + 1
    }));

    this.bannerSocialFilesStateService.setBannerSocialFilesState(updatedFiles);
    const draggedFile = updatedFiles[event.currentIndex];
    await this.bannerSocialFilesSyncService.updateFilePriority(
      draggedFile.id,
      draggedFile.priority
    );

    this.getFiles.emit();
  }
}
